import type { IconProps } from './types';

export const LogOut1Icon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
    >
      <path d="M13 3H4V21H13" stroke={color} strokeWidth="1.5" />
      <path d="M10.5001 11.75H17.9963" stroke={color} strokeWidth="1.5" />
      <path d="M15.25 15.5L19 11.75L15.25 8" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};
